import { createFileRoute } from '@tanstack/react-router';
import DocsGroupSectionLanding from '@/components/Docs/DocsGroupSectionLanding';

export const Route = createFileRoute('/developers/v2/$section/')({
  component: DevelopersV2SectionLandingPage,
});

function DevelopersV2SectionLandingPage() {
  const { section } = Route.useParams();
  return (
    <DocsGroupSectionLanding group="developers" sectionSlug={section} version="v2" />
  );
}
